 const RAC_DAO_LPADDR = '0xbCA0edA0CcaF9a93a4A46d4C2Ba3459972eb0c98'

 const RAC_DAO_PLEDGE_ADDR = '0x10B1c38F491c8bf3493a357714043987dFC094EE'

 export  { RAC_DAO_LPADDR, RAC_DAO_PLEDGE_ADDR }